import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  toggle({ detail: { content } }) {
    const isExpanding = content;
    const gridTemplateRows = isExpanding ? "1fr" : "0fr";

    this.contentTarget.style.gridTemplateRows = gridTemplateRows;
  }
}
